import { defineComponent, onMounted, onUnmounted } from 'vue'
import SockJS from 'sockjs-client'
import { CompatClient, Message, Stomp } from '@stomp/stompjs'
import { ucur } from '@/utils/env'
import { useComponentStore } from '../../nsh5/localStores/component'

export default defineComponent({
  name: 'ws-service',
  emits: ['receiveChargeMapMessage', 'receiveCityMessage', 'receiveIndicatorMessage'],
  setup: (props, { emit }) => {
    // 获取组件配置
    const componentsConfig: any = window.NSComponentsConfig
    const componentStore = useComponentStore()
    let stompClient: CompatClient | null = null // websocket客户端
    /**
     * 初始化websocket连接，获取换电站状态变化
     */
    const initWebSocket = () => {
      wsConnection()
    }

    const wsConnection = () => {
      const url = `https://pe-dingdong${ucur}.nio.com/pe/dingdong/msg?ws_app_id=100119`
      //连接服务端提供的通信接口
      const sock = new SockJS(url)
      // 获取STOMP子协议的客户端对象
      stompClient = Stomp.over(sock)
      stompClient.debug = () => {} // 关闭websocket控制台console输出
      stompClient.heartbeat.outgoing = 5000 // 每5s钟发送一次ping避免断开
      stompClient.heartbeat.incoming = 5000
      stompClient.connectionTimeout = 10000 // 超时重连
      // 向服务器发起websocket连接
      stompClient.connect(
        {},
        () => {
          wsSubscribe()
        },
        () => {
          console.log('链接失败')
        }
      )
      stompClient.onWebSocketClose = () => {
        // websocket断开重连
        wsDestroy()
        wsConnection()
      }
    }
    const wsSubscribe = () => {
      if (componentsConfig?.data_default?.properties?.realtime_swap_num !== 'on') {
        return
      }
      if (componentsConfig?.data_default?.properties?.type === 'somap') {
        // 服务中心 指标动态数据
        stompClient?.subscribe(
          '/room/h5/charge-map/indicator/basic/summary',
          (message: Message) => {
            try {
              const messageObj = JSON.parse(message.body)
              emit('receiveIndicatorMessage', messageObj)
              componentStore.bus.emit('onReceiveIndicatorMessage', messageObj)
              // message.ack(message.headers)
            } catch (error) {
              console.log(error)
            }
          }
        )
        return
      }
      // 订阅首页数据概览
      stompClient?.subscribe('/room/h5/charge-map/realtime-indicators', (message: Message) => {
        try {
          const messageObj = JSON.parse(message.body)
          emit('receiveChargeMapMessage', messageObj)
          // message.ack(message.headers)
        } catch (error) {
          console.log(error)
        }
      })
      // 订阅城市消息公告
      stompClient?.subscribe('/room/h5/charge-map/city/realtime-indicators', (message: Message) => {
        try {
          const messageObj = JSON.parse(message.body)
          emit('receiveCityMessage', messageObj)
          componentStore.bus.emit('onReceiveCityMessage', messageObj)
          // message.ack(message.headers)
        } catch (error) {
          console.log(error)
        }
      })
    }
    const wsDestroy = () => {
      if (stompClient != null) {
        stompClient.disconnect()
        // 销毁客户端
        stompClient = null
        console.log('websocket Destroy')
      }
    }

    onMounted(() => {
      initWebSocket()
    })

    onUnmounted(() => {
      // 断开websocket连接
      wsDestroy()
    })
    return () => {}
  },
})
